import React from 'react';
import { BookOpenIcon, FileTextIcon, BarChartIcon, InstagramIcon, PaletteIcon, CheckSquareIcon, AwardIcon } from 'lucide-react';
export function ProductIncludesSection() {
  return <section className="py-16 bg-gradient-to-b from-pink-50 to-white px-4" data-id="element-185">
      <div className="container mx-auto max-w-6xl" data-id="element-186">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-187">
          Tu Kit Profesional Incluye:
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-188">
          Todo lo que necesitas para transformar tu pasión por las uñas en un
          negocio rentable
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-189">
          <div className="bg-white p-8 rounded-xl shadow-lg border border-pink-100" data-id="element-190">
            <div className="flex items-center mb-6" data-id="element-191">
              <BookOpenIcon className="h-10 w-10 text-pink-500 mr-4" data-id="element-192" />
              <h3 className="text-2xl font-bold" data-id="element-193">Ebook + Masterclass</h3>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-194">
              Formación completa paso a paso en formato PDF y video para que
              puedas aprender a tu ritmo y consultar cuando lo necesites.
            </p>
            <ul className="space-y-2" data-id="element-195">
              <li className="flex items-start" data-id="element-196">
                <span className="text-pink-500 mr-2" data-id="element-197">•</span>
                <span data-id="element-198">7 capítulos detallados con todas las técnicas</span>
              </li>
              <li className="flex items-start" data-id="element-199">
                <span className="text-pink-500 mr-2" data-id="element-200">•</span>
                <span data-id="element-201">Videos explicativos de cada técnica</span>
              </li>
              <li className="flex items-start" data-id="element-202">
                <span className="text-pink-500 mr-2" data-id="element-203">•</span>
                <span data-id="element-204">Acceso inmediato y de por vida</span>
              </li>
              <li className="flex items-start" data-id="element-205">
                <span className="text-pink-500 mr-2" data-id="element-206">•</span>
                <span data-id="element-207">Actualizaciones gratuitas</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-lg border border-pink-100" data-id="element-208">
            <div className="flex items-center mb-0" data-id="element-209">
              <AwardIcon className="h-10 w-10 text-pink-500 mr-4" data-id="element-210" />
              <h3 className="text-2xl font-bold" data-id="element-211">6 Bonos Premium</h3>
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-medium mt-1 mb-3" data-id="element-212">
              GRATIS SOLO POR HOY
            </div>
            <div className="text-lg font-medium line-through text-gray-500 mb-3" data-id="element-213">
              150.000
            </div>
            <p className="text-gray-700 mb-4" data-id="element-214">
              Recursos exclusivos para acelerar tu crecimiento y destacar en el
              mercado:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-215">
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-216">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/udUcbXDK8FyN7Va7AaoxcW/BONO_1_MEJOR_FOTO.png" alt="Plantilla de precios editable" className="w-full h-40 object-contain mb-3" data-id="element-217" />
                <h4 className="font-semibold" data-id="element-218">BONO 1</h4>
                <p className="text-sm text-center" data-id="element-219">
                  Plantilla de precios editable
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-220">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-221">
                  Solo hoy gratis
                </p>
              </div>
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-222">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4q69QX8xAK8h9G1f678K1r/BONO_2.png" alt="Guía de marketing en redes" className="w-full h-40 object-contain mb-3" data-id="element-223" />
                <h4 className="font-semibold" data-id="element-224">BONO 2</h4>
                <p className="text-sm text-center" data-id="element-225">
                  Guía de marketing en redes
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-226">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-227">
                  Solo hoy gratis
                </p>
              </div>
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-228">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dci3hoUjNxMFDntV2nBF5W/BONO_3.png" alt="50 diseños virales paso a paso" className="w-full h-40 object-contain mb-3" data-id="element-229" />
                <h4 className="font-semibold" data-id="element-230">BONO 3</h4>
                <p className="text-sm text-center" data-id="element-231">
                  50 diseños virales paso a paso
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-232">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-233">
                  Solo hoy gratis
                </p>
              </div>
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-234">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uWjtsBYj2EKoPDFrigwPLV/BONO_4.png" alt="Plantillas editables en Canva" className="w-full h-40 object-contain mb-3" data-id="element-235" />
                <h4 className="font-semibold" data-id="element-236">BONO 4</h4>
                <p className="text-sm text-center" data-id="element-237">
                  Plantillas editables en Canva
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-238">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-239">
                  Solo hoy gratis
                </p>
              </div>
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-240">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dXckxoSfSa5hqgEx3ATWMk/BONO_5.png" alt="Checklist de productos esenciales" className="w-full h-40 object-contain mb-3" data-id="element-241" />
                <h4 className="font-semibold" data-id="element-242">BONO 5</h4>
                <p className="text-sm text-center" data-id="element-243">
                  Lista de productos necesarios para tecnicas de uñas
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-244">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-245">
                  Solo hoy gratis
                </p>
              </div>
              <div className="bg-pink-50 p-4 rounded-lg flex flex-col items-center" data-id="element-246">
                <div className="h-40 flex items-center justify-center mb-3" data-id="element-247">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8nnJNCzLQ1wh9BSAiNy3AM/BONO_6.png" alt="Certificado digital profesional" className="w-full h-full object-contain" data-id="element-248" />
                </div>
                <h4 className="font-semibold" data-id="element-249">BONO 6</h4>
                <p className="text-sm text-center" data-id="element-250">
                  Certificado digital profesional
                </p>
                <p className="text-sm line-through text-gray-500" data-id="element-251">$25.000</p>
                <p className="text-sm font-medium text-green-600" data-id="element-252">
                  Solo hoy gratis
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-253">
          <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 inline-block" data-id="element-254">
            QUIERO COMENZAR AHORA - $14.999
          </a>
        </div>
      </div>
    </section>;
}